import { Injectable } from '@angular/core';
// import { AppConfiguration } from '@symphony-solo/shared/app-configuration/src';
import { AppConfigService } from '@symphony-solo/domain/company-group/src';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';

const enum Api {
  ORDER = 'order',
  ORDER_VERIFY = 'verify',
  CREATE_PAYMENT_SESSION = 'payments/sessioncreate',
  RETRIEVE_PAYMENT_SESSION = 'payments/sessionretrieve',
}

@Injectable()
export class OrderService {
  private extraHeaders: { [name: string]: string | number } = {};
  constructor(private httpService: HttpService, private appConfigService: AppConfigService) {
    this.setHeader();
  }

  public setHeader() {
    let companyGUID = this.appConfigService.config?.companyGuid;
    if (this.appConfigService.getCompanyGroup) {
      companyGUID = this.appConfigService.getCompanyGroup?.companyGuid;
    }
    this.extraHeaders['CompanyGuid'] = companyGUID;
  }

  public verifyOrder(orderObject: any, draft?: string): Observable<any> {
    return this.httpService.makePost<any, any>('verify', orderObject.order, null, { CreateDraft: 'false' });
  }

  public applyDiscount(orderObject: any): Observable<any> {
    return this.httpService.makePostWithResponseHeaders<any, any>('discount', orderObject, null);
  }

  public applyGuestCheckoutDiscount(orderObject: any): Observable<any> {
    if (!this.extraHeaders['CompanyGuid']) {
      this.setHeader();
    }
    return this.httpService.makePost<any, any>('discountguestcheckout', orderObject, 'json', this.extraHeaders);
  }

  public sessionCreate(object: any): Observable<any> {
    return this.httpService.makePost<any, any>('payment/sessioncreate', object.sessionCreate);
  }

  public sessionCreateGuestCheckout(object: any): Observable<any> {
    if (!this.extraHeaders['CompanyGuid']) {
      this.setHeader();
    }
    return this.httpService.makePost<any, any>('payment/sessioncreateguestcheckout', object, 'json', this.extraHeaders);
  }

  public sessionRetrieve(object: any): Observable<any> {
    return this.httpService.makePost<any, any>('payment/sessionretrieve', `"${object.sessionRetrieve}"`);
  }

  public sessionRetrieveGuestCheckout(object: any, OrderID: number): Observable<any> {
    this.extraHeaders['OrderID'] = `${OrderID}`;
    this.extraHeaders['InvoiceID'] = object.sessionRetrieve;
    if (!this.extraHeaders['CompanyGuid']) {
      this.setHeader();
    }
    return this.httpService.makePost<any, any>('payment/sessionretrieveguestcheckout', null, 'json', this.extraHeaders);
  }

  public getOrderDetails(order: any): Observable<any> {
    return this.httpService.makeGet<void>(Api.ORDER + `/${order.id}`, null, null);
  }

  public orderComplete(): Observable<any> {
    return this.httpService.makePost<any, any>('complete', null);
  }
}
